import React from "react";
import TenantPicker from "../components/TenantPicker";
import { useRegistration, useRegistrationDispatch } from "../context/RegistrationContext";

export default function StepTenantSelector() {
  const state    = useRegistration();
  const dispatch = useRegistrationDispatch();

  const userEmail = localStorage.getItem("email") || "";

  // ClaimEnablement calls onComplete when the user picks/creates a Tenant.
  // It stores the selected account values in localStorage (nan, nid, sub, etc.)
  // and calls this callback so we can pull them into context.
  const handleTenantComplete = () => {
    const payload = {
      nca_nan:          localStorage.getItem("nan") || "",
      nca_nid:          localStorage.getItem("nid") || "",
      starfleet_id:     localStorage.getItem("sub") || "",
      idp_id:           localStorage.getItem("idp_id") || "",
      accountName:      localStorage.getItem("nna") || "",
      primaryOwnerEmail: localStorage.getItem("primaryowneremail") || "",
      sessionId:        localStorage.getItem("sid") || "",
      ngcProductNames:  localStorage.getItem("ngcProductNames") || "",
      showPicker:       true,
    };
    dispatch({ type: "TENANT_COMPLETE", payload });
    dispatch({ type: "NEXT_STEP" });
  };

  const user = {
    email:         userEmail,
    ngc_ProductFam: state.ngcProductFamily,
  };

  return (
    <div className="ucj-step-tenant">
      <TenantPicker
        productActivationId={state.pakId}
        user={user}
        onComplete={handleTenantComplete}
        ngc_ProductFam={state.ngcProductFamily}
        ngcProductNames={state.tenant.ngcProductNames}
        isMultiEnabled={false}
      />
    </div>
  );
}
